module.exports = __webpack_public_path__ + "img/Icon_LockOpen_ActiveRed.03b0433d.svg";